import Backbone from 'backbone';
import ko from 'knockout';

import ViewModel from './audienceModel';
import template from './audience.pug';
import { setPosition } from './const';

export class AudienceContextualAttributeView extends Backbone.View {
  initialize({
    deps,
    i18n,
    targetId,
  }) {
    this.deps = deps;
    this.i18n = i18n;
    this.audienceId = targetId;
    this.viewModel = new ViewModel({
      i18n,
    });
  }


  render() {
    const {
      deps,
      audienceId,
    } = this;

    // this.$el.html(template());
    // ko.applyBindings(this.viewModel, this.el);

    deps.jsdata.Audience.find(audienceId).then((response) => {
      if (response) {
        this.viewModel.updateAttribute({
          reachSize: response.Reach,
        });
        this.$el.html(template());
        ko.applyBindings(this.viewModel, this.el);
        const container = this.$el.children('.contextual-tooltip-container');
        setPosition(container);
      }
    });
    return this;
  }
}
